import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Box, Link, Desktop, Text } from '@miro-site/core';
import { useTranslation } from 'next-i18next';
import { Transition } from 'react-transition-group';
import styled from 'styled-components';
import { CategoryHeroBanner } from './CategoryHeroBanner';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SEPARATE_COLUMN_CATEGORIES_LIMIT = 12;

function splitCategories(resultArray, item, index) {
  var chunkIndex = Math.floor(index / SEPARATE_COLUMN_CATEGORIES_LIMIT);

  if (!resultArray[chunkIndex]) {
    resultArray[chunkIndex] = [];
  }

  resultArray[chunkIndex].push(item);
  return resultArray;
}

var transitionStyles = {
  entering: {
    opacity: 1,
    visibility: 'visible'
  },
  entered: {
    opacity: 1,
    visibility: 'visible'
  },
  exiting: {
    opacity: 0,
    visibility: 'hidden'
  },
  exited: {
    opacity: 0,
    visibility: 'hidden'
  }
};
var defaultStyle = {
  textAlign: 'center',
  transition: "opacity 250ms ease-in-out, visibility 250ms ease-in-out",
  visibility: 'hidden',
  opacity: 0
};

var getContent = function getContent(rootGroups, onCategoryOpen) {
  return rootGroups.map(function (group) {
    return /*#__PURE__*/_jsxs(RootGroupWrapper, {
      children: [/*#__PURE__*/_jsx(RootGroupTitle, {
        children: group.title
      }), /*#__PURE__*/_jsx(CategoriesListWrapper, {
        children: group.categories.reduce(splitCategories, []).map(function (categoryList, i) {
          return /*#__PURE__*/_jsx(Box, {
            children: categoryList.map(function (category) {
              return /*#__PURE__*/_jsx(CategoryLink, {
                onClick: function onClick(e) {
                  if (onCategoryOpen) {
                    e.preventDefault();
                    onCategoryOpen(category);
                  }
                },
                href: category.href,
                children: category.title
              }, category.title);
            })
          }, i);
        })
      })]
    }, group.title);
  });
};

var CategoryNavContent = function CategoryNavContent(_ref) {
  var isVisible = _ref.isVisible,
      styles = _ref.styles,
      _children = _ref.children;
  return /*#__PURE__*/_jsx(Transition, {
    "in": isVisible,
    timeout: 2500,
    children: function children(state) {
      return /*#__PURE__*/_jsx(Desktop, {
        $block: true,
        $styles: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, styles), defaultStyle), transitionStyles[state]), {}, {
          position: 'absolute',
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 3
        }),
        children: /*#__PURE__*/_jsx(Box, {
          $styles: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            textAlign: 'center'
          },
          children: _children
        })
      });
    }
  });
};

var CategoryNavDesktop = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var _ref2$styles = _ref2.styles,
      styles = _ref2$styles === void 0 ? {} : _ref2$styles,
      _ref2$rootGroups = _ref2.rootGroups,
      rootGroups = _ref2$rootGroups === void 0 ? [] : _ref2$rootGroups,
      _ref2$isVisible = _ref2.isVisible,
      isVisible = _ref2$isVisible === void 0 ? false : _ref2$isVisible,
      onCategoryOpen = _ref2.onCategoryOpen;

  var _useTranslation = useTranslation('common'),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(CategoryNavContent, {
    isVisible: isVisible,
    children: /*#__PURE__*/_jsx(NavWrapperVariant, {
      ref: ref,
      children: /*#__PURE__*/_jsxs(ContainerWrapper, {
        children: [/*#__PURE__*/_jsx(ListWrapper, {
          children: getContent(rootGroups, onCategoryOpen)
        }), /*#__PURE__*/_jsx(MiroverseWrapper, {
          children: /*#__PURE__*/_jsxs(RootGroupWrapper, {
            children: [/*#__PURE__*/_jsx(RootGroupTitle, {
              children: t('miroverse-title')
            }), /*#__PURE__*/_jsx(CategoriesListWrapper, {
              children: /*#__PURE__*/_jsx(CategoryHeroBanner, {})
            })]
          }, "Miroverse Templates")
        })]
      })
    })
  });
});
CategoryNavDesktop.displayName = 'CategoryNavDesktop';
var ContainerWrapper = styled(Box).attrs({
  $styles: {
    display: 'flex'
  }
}).withConfig({
  displayName: "Desktop__ContainerWrapper",
  componentId: "sc-12vazlf-0"
})([""]);
var ListWrapper = styled(Box).attrs({
  $styles: {
    flex: 0,
    display: 'inline-flex',
    textAlign: 'left',
    flexFlow: 'row nowrap',
    alignContent: 'flex-start'
  }
}).withConfig({
  displayName: "Desktop__ListWrapper",
  componentId: "sc-12vazlf-1"
})([""]);
var MiroverseWrapper = styled(Box).attrs({
  $styles: {
    flex: 0,
    flexBasis: 220,
    textAlign: 'left'
  }
}).withConfig({
  displayName: "Desktop__MiroverseWrapper",
  componentId: "sc-12vazlf-2"
})([""]);
var commomWrapperLayout = {
  paddingTop: [null, 48, 48, 48],
  paddingBottom: [null, 48, 48, 48],
  paddingLeft: [null, 95, 95, 95],
  paddingRight: [null, 53, 53, 53],
  borderRadius: [null, 16, 16, 16],
  boxShadow: '0px 8px 44px rgba(var(--wcds-colors-indigo-90-rgb), 0.16)',
  backgroundColor: 'primaryWhite'
};
var NavWrapperVariant = styled(Box).attrs(function (_ref3) {
  var _ref3$$styles = _ref3.$styles,
      $styles = _ref3$$styles === void 0 ? {} : _ref3$$styles;
  return {
    $styles: _objectSpread(_objectSpread({}, commomWrapperLayout), $styles)
  };
}).withConfig({
  displayName: "Desktop__NavWrapperVariant",
  componentId: "sc-12vazlf-3"
})({});
var RootGroupWrapper = styled(Box).attrs({
  $styles: {
    marginRight: [null, 28, 28, 28]
  }
}).withConfig({
  displayName: "Desktop__RootGroupWrapper",
  componentId: "sc-12vazlf-4"
})(["&:last-child{margin-right:0;}"]);
var RootGroupTitle = styled(Text).attrs(function (props) {
  return {
    as: 'div',
    $variant: 'p1',
    $styles: {
      fontSize: [null, 12, 12, 12],
      marginBottom: [null, 24, 24, 24],
      fontWeight: 'bold',
      lineHeight: [null, 24, 24, 24],
      letterSpacing: '1px',
      textTransform: 'uppercase',
      color: props.theme.templates.colors.secondary40
    }
  };
}).withConfig({
  displayName: "Desktop__RootGroupTitle",
  componentId: "sc-12vazlf-5"
})({});
var CategoriesListWrapper = styled(Box).attrs({
  $styles: {
    flex: 0,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    flexDirection: 'row',
    flexWrap: 'nowrap'
  }
}).withConfig({
  displayName: "Desktop__CategoriesListWrapper",
  componentId: "sc-12vazlf-6"
})({});
var CategoryLink = styled(Link).attrs({
  $size: 'small',
  $styles: {
    marginRight: [null, 16, 16, 16],
    marginBottom: [null, 8, 8, 8],
    width: [null, 160, 160, 160]
  }
}).withConfig({
  displayName: "Desktop__CategoryLink",
  componentId: "sc-12vazlf-7"
})(["display:block;font-weight:400;border-bottom:none;transition:color ", ";color:", ";&:hover{color:", ";}&:focus{", "}"], function (props) {
  return props.theme.animation.transitionDuration;
}, function (props) {
  return props.theme.colors.primaryIndigo;
}, function (props) {
  return props.theme.colors.primaryBlue;
}, function (props) {
  return props.theme.normalizeStyles(props.theme.focus.outlines.withOffset);
});
export default CategoryNavDesktop;